import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Drawer, DrawerContent, DrawerTitle } from '@/components/ui/drawer';
import { IS_USE_CENTIMETERS_SIZE_COUNTRY } from '@/constants/is-use-centimeters-size-country';
import useIsMobile from '@/hooks/use-is-mobile';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
const HeightTipDialog = (props: Props) => {
  const { open, onConfirm, onCancel } = props;
  const isMobile = useIsMobile();

  const content = (
    <>
      <div className='flex justify-end'>
        <button
          type='button'
          className='flex h-[46px] w-[46px] items-center justify-center lg_h-[60px] lg_w-[60px]'
          onClick={onCancel}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            fill='none'
            viewBox='0 0 18 18'
            className='h-auto w-4'
          >
            <path
              stroke='#80583F'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
              d='M17 17 1 1m16 0L1 17'
            ></path>
          </svg>
        </button>
      </div>
      <div className='mt-[71px] px-[37px] pb-[107px] lg_mt-[34px] lg_px-[50px] lg_pb-[84px]'>
        <p className='text-[17px] leading-[1.7]'>
          Heads up! The usual difference between height and hollow to hem is{' '}
          {IS_USE_CENTIMETERS_SIZE_COUNTRY ? '25.4cm-38.1cm' : '10inch-15inch'}. Yours is slightly outside that range.
          Want to double-check or continue?
        </p>
        <button
          type='button'
          onClick={onCancel}
          className='group mt-[60px] flex h-[50px] w-full items-center justify-center gap-x-2.5 rounded-[3px] border-1  border-solid border-80583F bg-80583F text-white lg_hover_bg-white lg_hover_text-80583F'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            fill='none'
            viewBox='0 0 20 20'
          >
            <path
              className='fill-white lg_group-hover_fill-80583F'
              d='M18.604 8.98a.68.68 0 0 0-.964 0l-.412.412c-.42-3.994-3.806-7.119-7.91-7.119a8 8 0 0 0-1.407.133c-.092.016-.184.03-.274.05q-.288.062-.57.147-.198.061-.395.132-.104.037-.207.077-.212.08-.418.173l-.087.042a8 8 0 0 0-.88.481l-.038.023A8.033 8.033 0 0 0 3.457 4.87q-.073.077-.142.156A7.955 7.955 0 0 0 2.17 6.76q-.031.06-.06.119-.006.013-.01.025a7.9 7.9 0 0 0-.738 3.325c0 4.386 3.568 7.955 7.955 7.955a7.9 7.9 0 0 0 6.803-3.83.682.682 0 0 0-1.166-.708 6.55 6.55 0 0 1-5.637 3.174 6.6 6.6 0 0 1-6.591-6.591c.001-.976.22-1.94.643-2.82A6.6 6.6 0 0 1 4.359 5.9l.066-.073q.429-.475.94-.861l.064-.048c.355-.26.736-.485 1.135-.67l.037-.019q.254-.114.516-.206a6 6 0 0 1 .807-.235q.115-.022.231-.042.285-.05.575-.08.291-.029.588-.03c3.308 0 6.047 2.453 6.513 5.633l-.29-.29a.681.681 0 1 0-.963.964l1.53 1.532a.683.683 0 0 0 .964 0l1.532-1.532a.68.68 0 0 0 0-.963'
            ></path>
          </svg>
          <span className='text-[15px] font-medium'>DOUBLE-CHECK MEASUREMENTS</span>
        </button>
        <button
          type='button'
          onClick={onConfirm}
          className=' mt-5 flex h-[50px] w-full items-center justify-center gap-x-2.5 rounded-[3px] border-1  border-solid border-80583F  text-80583F '
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            fill='none'
            viewBox='0 0 18 18'
          >
            <path
              stroke='#80583F'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
              d='M9.633 1.406 17.227 9l-7.594 7.594M16.172 9H.773'
            ></path>
          </svg>
          <span className='text-[15px] font-medium'>CONTINUE</span>
        </button>
      </div>
    </>
  );

  return isMobile ? (
    <Drawer
      direction='bottom'
      open={open}
      onOpenChange={onCancel}
    >
      <DrawerContent
        className='fixed bottom-0 left-0 z-[2110] w-full rounded-tl-[3px] rounded-tr-[3px] bg-white'
        maskClassName='z-[2100]'
      >
        <DrawerTitle className='hidden'>height tip drawer</DrawerTitle>
        {content}
      </DrawerContent>
    </Drawer>
  ) : (
    <Dialog
      open={open}
      onOpenChange={onCancel}
    >
      <DialogContent
        showCloseButton={false}
        className='z-[2110] gap-0 p-0'
        maskClassName='z-[2100]'
      >
        <DialogTitle className='hidden'>height tip dialog</DialogTitle>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default HeightTipDialog;
